export const modalButton = {
  paddingLeft: 50,
  paddingRight: 50,
  fontSize: 10,
  fontWeight: 600,
  marginTop: 80,
  background: 'var(--ete-primary-green-color)',
  width: '215px',
} as React.CSSProperties;

export const modalButtonLoad = {
  paddingLeft: 50,
  paddingRight: 50,
  fontSize: 10,
  fontWeight: 600,
  marginTop: 10,
  marginLeft: 220,
  background: 'var(--ete-primary-green-color)',
  width: '215px',
} as React.CSSProperties;

export enum OntologyAndFlowOptionType {
  DEFAULT = 1,
  FROM_EVENT = 2,
  EMPTY = 3,
}

export interface OntologyAndFlowOption {
  type: OntologyAndFlowOptionType;
  fromEventId?: string;
}
